// BHP-1063: DNS read hooks over Backend2.0 (Hydra).
//
// The zone is reached through the domain's `dnsZoneUuid`; its records come from
// the collection narrowed by the `app.filter.dns_record_search` filter added in
// this story. Both are customer-scoped server-side by CustomerScopeExtension
// (dns record → zone → domain → subscriptions).
import { type UseQueryResult } from '@tanstack/react-query';
import { useCollection, useItem } from '../../../shared/api/useHydra';
import { type HydraCollection } from '../../../shared/api/hydra';
import type { DnsRecord, DnsZone } from '../dns';

export function useDnsZone(uuid: string | null): UseQueryResult<DnsZone> {
  return useItem<DnsZone>('dns_zones', uuid ?? '', { enabled: uuid !== null });
}

/**
 * Records of one zone, optionally narrowed by a (partial) name search — the
 * search half covers BHP-504.
 */
export function useDnsRecords(
  zoneUuid: string | null,
  search = '',
  page = 1
): UseQueryResult<HydraCollection<DnsRecord>> {
  return useCollection<DnsRecord>('dns_records', {
    enabled: zoneUuid !== null,
    page,
    params: {
      'dnsZone.uuid': zoneUuid ?? '',
      name: search.trim() === '' ? undefined : search.trim()
    }
  });
}
